import { expand } from 'uri-template-lite';
import { apiClient } from '../../common/ApiClient';
import { RoleUrl } from './RoleUrl';
import { createApiQueryHook } from '../../common/queryClient/createApiQueryHook';
import { RoleDto } from '../schema/types';
import { RoleSchema } from '../schema/RoleSchema';

const getRole = ({ id }: { id: number }) =>
  apiClient
    .get<RoleDto>(expand(RoleUrl.ROLE, { id }))
    .then((response) => RoleSchema.parse(response.data));

export const useRoleQuery = createApiQueryHook(['role'], getRole);
